import { render } from "./menu.html?vue&type=template&id=682c37bd&scoped=true&ts=true"
import script from "./menu.ts?vue&type=script&lang=ts"
export * from "./menu.ts?vue&type=script&lang=ts"

import "./menu.scss?vue&type=style&index=0&id=682c37bd&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682c37bd"]])

export default __exports__